// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"840fa7d7","963":"cd5c1d17"}[chunkId] + ".chunk.js";
};